import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import extraReducers from "../store/extraReducers";

import type { ApartmentType } from "@stepapp/core/apiTypes";

const initialState = {
  homeType: "",
  floorArea: 0,
  newPropertyId: "",
  localizationId: "",
  city: "",
};

const homeProfileSlice = createSlice({
  name: "homeProfile",
  initialState,
  extraReducers: extraReducers(initialState),
  reducers: {
    setHomeType: (state, { payload }: PayloadAction<ApartmentType>) => {
      state.homeType = payload;
    },

    setHomeSize: (state, { payload }: PayloadAction<number>) => {
      state.floorArea = payload;
    },
    setHomeId: (state, { payload }: PayloadAction<string>) => {
      state.newPropertyId = payload;
    },
    setHomeProfile: (
      state,
      {
        payload,
      }: PayloadAction<{ homeType: ApartmentType; floorArea: number; propertyId: string }>,
    ) => {
      state.homeType = payload.homeType;
      state.floorArea = payload.floorArea;
      state.newPropertyId = payload.propertyId;
    },

    resetHomeProfile: () => initialState,
  },
});

export const { setHomeType, resetHomeProfile, setHomeSize, setHomeProfile, setHomeId } =
  homeProfileSlice.actions;

export default homeProfileSlice.reducer;
